import { render, staticRenderFns } from "./changeWeek.vue?vue&type=template&id=52d1b9de&"
import script from "./changeWeek.vue?vue&type=script&lang=js&"
export * from "./changeWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports